/*
 * @Author: chenyan
 * @Date: 2017-12-07 13:59:36
 * @Description:
 * @Last Modified by: wanghf
 * @Last Modified time: 2025-04-07 17:02:29
 */

const main = resolve => require(['@/views/index/index.vue'], resolve) // 主页

const websiteList = resolve =>
  require(['@/views/websiteCenter/websiteManage/websiteList/index.vue'], resolve) // 网站列表

const accountBalance = resolve =>
  require(['@/views/fundManagement/accountBalance/index.vue'], resolve) // 账户余额

const withdrawalDetail = resolve =>
  require(['@/views/fundManagement/withdrawalDetail/index.vue'], resolve) // 提现明细

const unsettledBalance = resolve =>
  require(['@/views/fundManagement/unsettledBalance/index.vue'], resolve) // 提现明细

const groupManage = resolve =>
  require(['@/views/websiteCenter/groupManage/groupManage.vue'], resolve) //  群组管理

const storeOnboarding = resolve =>
  require(['@/views/websiteCenter/websiteManage/storeOnboarding/index.vue'], resolve) //  店铺进件查询
const paymentLinkIndex = resolve =>
  require(['@/views/paymentLink/paymentLink/index.vue'], resolve) //  支付链

const brandList = resolve =>
  require(['@/views/paymentLink/brandInfo/brandList'], resolve) //  品牌信息列表

const paymentLinkTemplateList = resolve =>
  require(['@/views/paymentLink/templateManage/templateList'], resolve) //  支付链模版管理

const paymentLinkThemeList = resolve =>
  require(['@/views/paymentLink/themeManage/list'], resolve) //  支付链主题管理

const paymentLinkModeList = resolve =>
  require(['@/views/paymentLink/modeManage/list'], resolve) //  支付链模式管理

const checkoutCustomSettings = resolve =>
  require(['@/views/checkoutCustomSettings/index.vue'], resolve) //  收银台自定义

const storeManage = resolve =>
  require(['@/views/storeManage/index.vue'], resolve) // 门店管理

const addStore = resolve =>
  require(['@/views/storeManage/store/addStore.vue'], resolve) // 新增门店

const storeDetail = resolve =>
  require(['@/views/storeManage/store/storeDetail.vue'], resolve) // 门店详情

export default [{
  path: '/index',
  component: main,
  children: [
    // 网站管理
    {
      name: 'WebsiteList',
      path: '/aq/websiteList',
      alias: ['/aq/websiteList.htm'],
      component: websiteList
    },
    {
      name: 'GroupManage',
      path: '/aq/groupManage',
      alias: ['/aq/groupManage.htm'],
      component: groupManage
    },
    // 店铺进件查询
    {
      name: 'StoreOnboarding',
      path: '/aq/storeOnboarding',
      alias: ['/aq/storeOnboarding.htm'],
      component: storeOnboarding
    },
    // 账户余额
    {
      name: 'AccountBalance',
      path: '/aq/accountBalance',
      alias: ['/aq/accountBalance.htm'],
      component: accountBalance
    },
    // 提现明细
    {
      name: 'WithdrawalDetail',
      path: '/aq/withdrawalDetail',
      alias: ['/aq/withdrawalDetail.htm'],
      component: withdrawalDetail
    },
    // 待结算交易统计
    {
      name: 'UnsettledBalance',
      path: '/aq/unsettledBalance',
      alias: ['/aq/unsettledBalance.htm'],
      component: unsettledBalance
    },

    // 支付链
    {
      name: 'PaymentLink',
      path: '/aq/paymentLink',
      alias: ['/aq/paymentLink.htm'],
      component: paymentLinkIndex
    },
    // 品牌信息列表
    {
      name: 'BrandList',
      path: '/aq/brandList',
      alias: ['/aq/brandList.htm'],
      component: brandList
    },
    // 模版管理
    {
      name: 'paymentLinkTemplateList',
      path: '/aq/paymentLinkTemplateList',
      alias: ['/aq/paymentLinkTemplateList.htm'],
      component: paymentLinkTemplateList
    },
    // 主题管理
    {
      name: 'paymentLinkThemeList',
      path: '/aq/paymentLinkThemeList',
      alias: ['/aq/paymentLinkThemeList.htm'],
      component: paymentLinkThemeList
    },
    // 模式管理
    {
      name: 'paymentLinkModeList',
      path: '/aq/paymentLinkModeList',
      alias: ['/aq/paymentLinkModeList.htm'],
      component: paymentLinkModeList
    },
    // 门店管理
    {
      name: 'storeManage',
      path: '/aq/storeManage',
      alias: ['/aq/storeManage.htm'],
      component: storeManage
    },
    // 新增门店
    {
      name: 'addStore',
      path: '/aq/addStore',
      alias: ['/aq/addStore.htm'],
      component: addStore
    },
    // 门店详情
    {
      name: 'storeDetail',
      path: '/aq/storeDetail',
      alias: ['/aq/storeDetail.htm'],
      component: storeDetail
    }
  ]
}, {
  // 收银台自定义
  name: 'checkoutCustomSettings',
  path: '/aq/checkoutCustomSettings',
  alias: ['/aq/checkoutCustomSettings.htm'],
  component: checkoutCustomSettings
}]
